import React from 'react'
import classes from './Accordion.module.scss'

const Accordion = (props) => {
    return (
        <div className={`accordion-item accordion-style-2 rounded mt-3 ${classes.accordion}`}>
            <h2 className="accordion-header" id={`heading${props.id}`}>
            <button className={`accordion-button collapsed ${classes.button}`} type="button" data-bs-toggle="collapse"
                data-bs-target={`#collapse${props.id}`} aria-expanded="true" aria-controls={`collapse${props.id}`}>
                <span className={classes.buttonText}>{props.title}</span>
            </button>
            </h2>
            <div id={`collapse${props.id}`} className="accordion-collapse collapse" aria-labelledby={`heading${props.id}`}
            data-bs-parent="#faq">
            <div className={`accordion-body ${classes.body}`}>
                <span className={classes.bodyText} dangerouslySetInnerHTML={{__html: props.text}}></span>
            </div>
            </div>
        </div>
    )
}

export default Accordion
